@if (showCampaignBanner && slides().length > 0) {
  <p-carousel
    [value]="slides()"
    [circular]="true"
    [autoplayInterval]="3600"
    [showIndicators]="false"
    [page]="0"
  >
    <ng-template let-slide pTemplate="item">
      @if (slide.href) {
        <a [href]="slide.href" target="_blank" aria-label="slide">
          <afra-image
            imgClass="rounded-lg"
            [fileId]="slide.id"
            [alt]="slide.alt"
          ></afra-image>
        </a>
      } @else {
        <afra-image
          imgClass="rounded-lg"
          [fileId]="slide.id"
          [alt]="slide.alt"
        ></afra-image>
      }
    </ng-template>
  </p-carousel>
}
